module.exports = __webpack_public_path__ + "img/search-icon-with-bg-red.c3489662.svg";